import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/popup-images")({
  component: lazyRouteComponent(() => import("./-pages/admin.popup-images")),
  head: () => ({ meta: [{ title: "صور النافذة المنبثقة — Admin" }] }),
});
